import { TouristGroup } from '@ve/types';
import Backbone from 'backbone';

export default (hotelCardRightBlockDataForProps: {
    product: Backbone.Model,
    productType: 'tourOffer',
    productPrice: number,
}): {
    touristGroup: TouristGroup,
    checkInDate: string,
    nights: number,
    productPrice: number,
    productType: string,
    tooltipBottomText: string,
    promoSegmentId?: number | null,
} => {
    const getTooltipBottomText = () => {
        switch (hotelCardRightBlockDataForProps.productType) {
            default:
                return 'В стоимость тура обычно входит: номер в отеле, питание, перелёты, страховка, трансфер — по выбору';
        }
    };
    return {
        touristGroup: hotelCardRightBlockDataForProps.product.get('touristGroup'),
        checkInDate: hotelCardRightBlockDataForProps.product.get('checkInDate'),
        nights: hotelCardRightBlockDataForProps.product.get('nights'),
        productPrice: hotelCardRightBlockDataForProps.productPrice,
        productType: hotelCardRightBlockDataForProps.productType,
        tooltipBottomText: getTooltipBottomText(),
        promoSegmentId: hotelCardRightBlockDataForProps.product.get('promoSegmentId'),
    };
};